import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./home.scss";
import { useSelector, useDispatch } from "react-redux";
import { handleSelectYear } from "../../redux/slice/headerSlice";
import { fetchStateData } from "../../redux/thunks/stateThunk";
import { fetchYearData } from "../../redux/thunks/yearThunk";
import { fetchDistrictDataByStateCode } from "../../redux/thunks/districtThunk";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import udiseplusLogo from "../../assets/images/udiseplu.jpg";
import nicLogo from "../../assets/images/nic-sm-logo.png";
import downloadIcon from "../../assets/images/pdf2.svg";
import resetIcon from "../../assets/images/refresh.svg";
import { fetchBlockByDistrictCode } from "../../redux/thunks/blockThunk";

export default function Heilight() {
  const dispatch = useDispatch();

  const yearData = useSelector((state) => state?.year?.data?.data);
  const year = useSelector((state) => state.header.selectYear);

  const stateData = useSelector((state) => state.state);
  const districtData = useSelector((state) => state.distrct);
  const blockData = useSelector((state) => state.block);
  const [selectedState, setSelectedState] = useState(99);
  const [selectedDistrict, setSelectedDistrict] = useState(10);
  const [selectedBlock, setSelectedBlock] = useState(12);   // 12 becouse initail district code have 12 for all blocks.
  const [data, setData] = useState(null);
  const [migData, setMigData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(yearData?.[0]?.yearId);
  const [regionCode, setRegionCode] = useState(99);
  const [regionType, setRegionType] = useState(10);

  const yearObj = {
    // 12: "2025-26",
    11: "2024-25",
    10: "2023-24",
    9: "2022-23",
    8: "2021-22",
  };

  console.log('blockData', blockData);
  const fetchEduHighlights = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        "https://api.udiseplus.gov.in/open-services/v1.1/kpi/edu-highlights",
        {
          yearId: selectedYear,
          regionCode: regionCode,
          regionType: regionType,
          valueType: 1,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      setData(res.data.data[0]);
      console.log("res.data", res.data.data[0]);
    } catch (err) {
      console.error("API Error:", err);
    }
    setLoading(false);
  };

  const fetchEduMigrationHighlights = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        "https://api.udiseplus.gov.in/open-services/v1.1/kpi/edu-migration-highlights",
        {
          yearId: selectedYear,
          regionCode: regionCode,
          regionType: regionType,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      setMigData(res.data.data);
      console.log("migration res.data", migData);
    } catch (err) {
      console.error("API Error:", err);
    }
    setLoading(false);
  };

  const tables = [
    {
      title: "Schools",
      rows: [
        { label: "Total Number of Schools", value: "totSch" },
        { label: "Total number of Kendriya Vidyalaya (KVs)", value: "tschKv" },
        { label: "Total number of Navodaya Vidyalaya (NVs)", value: "tschNv" },
        { label: "Other Central Government", value: "tschOthCenGovt" },
        { label: "State Government", value: "tschStatGovt" },
        { label: "Total Government Schools", value: "tschGovt" },
        { label: "Total Government Aided Schools", value: "tschGovtAided" },
        {
          label: "Total Private Unaided Recognized Schools",
          value: "tschPvtUnaided",
        },
        { label: "Total Other Schools", value: "tschOth" },
        {
          label: "Number of Government Schools having Primary levels",
          value: "tschGovtPri",
        },
        {
          label: "Number of Government Aided Schools having Primary levels",
          value: "tschGovtAidedPri",
        },
        {
          label:
            "Number of Government and Government Aided Primary Schools having Balavatika/ Pre-Primary sections",
          value: "tschGovtAidedPri2",
        },
      ],
    },
    {
      title: "Schools As per School Category",
      rows: [
        { label: "Primary School (1-5)", value: "tsch1to5" },
        { label: "Upper Primary School (1-8)", value: "tsch1to8" },
        { label: "Upper Primary School (6-8)", value: "tsch6to8" },
        { label: "Secondary School (1-10)", value: "tsch1to10" },
        { label: "Secondary School (6-10)", value: "tsch6to10" },
        { label: "Secondary School (9-10)", value: "tsch9to10" },
        { label: "Higher Secondary School (1-12)", value: "tsch1to12" },
        { label: "Higher Secondary School (6-12)", value: "tsch6to12" },
        { label: "Higher Secondary School (9-12)", value: "tsch9to12" },
        { label: "Higher Secondary School (11-12)", value: "tsch11to12" },
      ],
    },
    {
      title: "Enrolments",
      rows: [
        {
          label: "Total Number of Enrolments (Foundational to Secondary)",
          value: "tenrF2Sec",
        },
        { label: "Enrolment in Foundational", value: "tenrF" },
        { label: "Enrolment in Preparatory", value: "tenrP" },
        { label: "Enrolment in Middle", value: "tenrM" },
        { label: "Enrolment in Secondary", value: "tenrS" },
        {
          label: "Number of SC Students (Foundational to Secondary)",
          value: "tenrF2SecSc",
        },
        {
          label: "Number of ST Students (Foundational to Secondary)",
          value: "tenrF2SecSt",
        },
        {
          label: "Number of OBC students (Foundational to Secondary)",
          value: "tenrF2SecObc",
        },
        {
          label:
            "Total number of Minority Enrolments (Foundational to Secondary)",
          value: "tenrF2SecMinority",
        },
        {
          label: "Number of CWSN students (Foundational to Secondary)",
          value: "tenrFSecCwsn",
        },
        {
          label: "Total number of Enrolments in Kendriya Vidyalaya (KVs)",
          value: "tenrF2SecKv",
        },
        {
          label: "Total number of Enrolments in Navodaya Vidyalaya (NVs)",
          value: "tenrF2SecNv",
        },
        {
          label: "Enrolments in Other Central Government schools",
          value: "tenrF2SecOthCgov",
        },
        {
          label: "Enrolments in State Government schools",
          value: "tenrF2SecStateGov",
        },
        { label: "Enrolments in Government Schools", value: "tenrF2SecGov" },
        {
          label: "Enrolments in Government Aided schools",
          value: "tenrF2SecGovAided",
        },
        {
          label: "Enrolments in Private Unaided Recognized schools",
          value: "tenrF2SecPvtUnaided",
        },
        { label: "Enrolments in Other schools", value: "tenrF2SecOth" },
      ],
    },
    {
      title: "Enrolments by School Category",
      rows: [
        { label: "Primary School (1-5)", value: "tenr1to5" },
        { label: "Upper Primary School (1-8)", value: "tenr1to8" },
        { label: "Upper Primary School (6-8)", value: "tenr6to8" },
        { label: "Secondary School (1-10)", value: "tenr1to10" },
        { label: "Secondary School (6-10)", value: "tenr6to10" },
        { label: "Secondary School (9-10)", value: "tenr9to10" },
        { label: "Higher Secondary School (1-12)", value: "tenr1to12" },
        { label: "Higher Secondary School (6-12)", value: "tenr6to12" },
        { label: "Higher Secondary School (9-12)", value: "tenr9to12" },
        { label: "Higher Secondary School (11-12)", value: "tenr11to12" },
      ],
    },
    {
      title: "Teachers",
      rows: [
        { label: "Total Number of teachers", value: "ttch" },
        {
          label: "Total number of teachers in Kendriya Vidyalaya (KVs)",
          value: "ttchKv",
        },
        {
          label: "Total number of teachers in Navodaya Vidyalaya (NVs)",
          value: "ttchNv",
        },
        {
          label: "Other Central Government schools",
          value: "ttchOthCenGovt",
        },
        { label: "State Government schools", value: "ttchState" },
        { label: "Government Schools", value: "ttchGovt" },
        { label: "Government Aided schools", value: "ttchGovtAided" },
        {
          label: "Private Unaided Recognized schools",
          value: "ttchPvtUnaided",
        },
        { label: "Other schools", value: "ttchOth" },
      ],
    },
    {
      title: "Pupil Teacher Ratio (PTR)",
      rows: [
        { label: "PTR at Foundational level", value: "foundation" },
        { label: "PTR at Preparatory level", value: "preparatory" },
        { label: "PTR at Middle level", value: "middle" },
        { label: "PTR at Secondary level", value: "secondary" },
      ],
    },
    {
      title: "Gross Enrolment Ratio (GER)",
      rows: [
        { label: "Gross Enrolment Ratio (GER) – Foundational", value: "fger" },
        { label: "Gross Enrolment Ratio (GER) – Preparatory", value: "pger" },
        { label: "Gross Enrolment Ratio (GER) – Middle", value: "mger" },
      ],
    },
    {
      title: "Dropout Rates",
      rows: [
        { label: "Dropout Rates - Preparatory", value: "dpt" },
        { label: "Dropout Rates – Middle", value: "dmt" },
        { label: "Dropout Rates - Secondary", value: "dst" },
      ],
    },
    {
      title: "Transition Rates",
      rows: [
        {
          label: "Transition Rates Foundational to Preparatory",
          value: "tft",
        },
        { label: "Transition Rates Preparatory to Middle", value: "tmt" },
        { label: "Transition Rates Middle to Secondary", value: "tst" },
      ],
    },
    {
      title: "Infrastructure Facilities",
      rows: [
        {
          label: "Percentage of schools having electricity connection",
          value: "elecPer",
        },
        {
          label: "Percentage of schools having drinking water facility",
          value: "waterPer",
        },
        {
          label: "Percentage of schools having toilet facility",
          value: "toiletPer",
        },
        {
          label: "Percentage of schools having boys’ toilet facility",
          value: "toiletBPer",
        },
        {
          label: "Percentage of schools having girls’ toilet facility",
          value: "toiletGPer",
        },
        {
          label: "Percentage of schools having hand wash facilities",
          value: "handwashPer",
        },
        {
          label: "Percentage of schools having playground facility",
          value: "pgroundPer",
        },
        {
          label: "Percentage of schools having computer facility",
          value: "compPer",
        },
        {
          label: "Percentage of schools having internet facility",
          value: "internetPer",
        },
        {
          label: "Percentage of schools having CWSN friendly toilets",
          value: "toiletCwsnPer",
        },
        {
          label:
            "Percentage of schools having ramps with handrail facility for CWSN students",
          value: "rampWithHandrailPer",
        },
        {
          label: "Percentage of schools having Kitchen Gardens",
          value: "kitGardPer",
        },
        {
          label: "Percentage of schools having Rainwater Harvesting System",
          value: "rainWatPer",
        },
        {
          label:
            "Percentage of schools having Libraries/Reading Corner/Book Bank facilities",
          value: "libBbnkRcorPer",
        },
        {
          label: "Percentage of schools having functional smart classrooms",
          value: "smartPerFun",
        },
        {
          label:
            "Percentage of schools having functional electricity connection",
          value: "elecPerFun",
        },
        {
          label:
            "Percentage of schools having functional drinking water facility",
          value: "waterPerFun",
        },
        {
          label: "Percentage of schools having functional toilet facility",
          value: "toiletPerFun",
        },
        {
          label:
            "Percentage of schools having functional boys’ toilet facility",
          value: "toiletBPerFun",
        },
        {
          label:
            "Percentage of schools having functional girls’ toilet facility",
          value: "toiletGPerFun",
        },
        {
          label: "Percentage of schools having functional computer facility",
          value: "compPerFun",
        },
        {
          label:
            "Percentage of schools having functional CWSN friendly toilets	",
          value: "toiletCwsnPerFun",
        },
      ],
    },
    {
      title: "Performance Grading Index State",
      rows: [
        {
          label: "Overall Score ",
          value: "overallScore",
        },
        { label: "Overall Grade ", value: "overallGrade" },
      ],
    },
  ];

  const migTables = [
    {
      title: "Total Migration",
      migId: 0,
      rows: [
        {
          indicator: "PS (1-5)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (1-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (6-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (1-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (6-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (9-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (1-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (6-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (9-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (11-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "PRE (Pre-Primary)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
      ],
    },
      {
      title: "Migration to other State",
      migId: 1,
      rows: [
        {
          indicator: "PS (1-5)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (1-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (6-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (1-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (6-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (9-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (1-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (6-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (9-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (11-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "PRE (Pre-Primary)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
      ],
    },
    {
      title: "Migration Within Same District ",
      migId: 2,
      rows: [
        {
          indicator: "PS (1-5)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (1-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (6-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (1-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (6-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (9-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (1-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (6-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (9-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (11-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "PRE (Pre-Primary)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
      ],
    },
    {
      title: "Migration to another district of the same State ",
      migId: 3,
      rows: [
        {
          indicator: "PS (1-5)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (1-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (6-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (1-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (6-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (9-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (1-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (6-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (9-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (11-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "PRE (Pre-Primary)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
      ],
    },
    {
      title: "Migration to the district of another State",
      migId: 4,
      rows: [
        {
          indicator: "PS (1-5)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (1-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (6-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (1-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (6-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (9-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (1-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (6-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (9-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (11-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "PRE (Pre-Primary)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
      ],
    },
    {
      title: "Total Migration to same Block",
      migId: 5,
      rows: [
        {
          indicator: "PS (1-5)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (1-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (6-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (1-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (6-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (9-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (1-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (6-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (9-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (11-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "PRE (Pre-Primary)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
      ],
    },
    {
      title: "Total Migration to another Block and same District",
      migId: 6,
      rows: [
        {
          indicator: "PS (1-5)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (1-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (6-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (1-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (6-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (9-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (1-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (6-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (9-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (11-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "PRE (Pre-Primary)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
      ],
    },
    {
      title: "Total Migration to another Block and another District in same State",
      migId: 7,
      rows: [
        {
          indicator: "PS (1-5)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (1-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (6-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (1-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (6-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (9-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (1-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (6-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (9-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (11-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "PRE (Pre-Primary)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
      ],
    },
    {
      title: "Total Migration to another Block and another State",
      migId: 8,
      rows: [
        {
          indicator: "PS (1-5)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (1-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "UPS (6-8)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (1-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (6-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "SS (9-10)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (1-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (6-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (9-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "HSS (11-12)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
        {
          indicator: "PRE (Pre-Primary)",
          a: "ps1To5",
          b: "ups1To8",
          c: "ups6To8",
          d: "ss1To10",
          e: "ss6To10",
          f: "ss9To10",
          g: "hss1To12",
          h: "hss6To12",
          i: "hss9To12",
          j: "hss11To12",
          h: "prePri",
        },
      ],
    },
  ];


  const handleResetBtn = () => {
    setSelectedState(99);
    setSelectedDistrict(10);
    setSelectedBlock(12);
    setRegionType(10)
    setRegionCode(99)
    setSelectedYear(11)
  }
  // Handle dropdown change (NO DISPATCH)
  const handleYearChange = (e) => {
    const yearId = Number(e.target.value);
    setSelectedYear(yearId); 
  };

  // 1) SET DEFAULT YEAR AFTER yearData LOADS
  useEffect(() => {
    console.log("year", year);
    if (yearData?.length) {
      dispatch(handleSelectYear(yearData[0].yearDesc));
    }
  }, [yearData, dispatch]);

  // 2) FETCH STATE LIST WHEN yearData IS AVAILABLE
  useEffect(() => {
    if (yearData?.length && yearData[0]?.yearId) {
      dispatch(fetchStateData(yearData[0].yearId));
      console.log("stateData", stateData);
    }
  }, [yearData, dispatch]);

  useEffect(() => {
    if (selectedState && yearData?.length) {
      dispatch(
        fetchDistrictDataByStateCode({
          state_code: selectedState,
          yearId: yearData[0].yearId,
        })
      );
    }
  }, [selectedState, yearData, dispatch]);


  useEffect(() => {
    if (selectedState && selectedDistrict && yearData?.length) {
      dispatch(
         fetchBlockByDistrictCode({
          district_code: selectedDistrict,
          yearId: yearData[0].yearId,
        })
      );
    }
  }, [selectedState,selectedDistrict, yearData, dispatch]);


  useEffect(() => {
    fetchEduHighlights();
    fetchEduMigrationHighlights();
  }, [selectedYear, selectedState, selectedDistrict, selectedBlock]);

  const handleStateChange = (e) => {
    setSelectedState(e.target.value);
    setSelectedBlock(12)
    if (e.target.value === "99") {
      setRegionCode(99);
      setRegionType(10);
    } else {
      setRegionCode(e.target.value);
      setRegionType(11);
    }
  };

  const handleDistrictChange = (e) => {
    setSelectedDistrict(e.target.value);
    if (e.target.value === "10") {
      setRegionCode(selectedState);
      setRegionType(11);
    } else {
      setRegionCode(e.target.value);
      setRegionType(12);
    }
  };

  const handleBlockChange = (e) => {
    setSelectedBlock(e.target.value);
     if (e.target.value === "12") {
      setRegionCode(selectedDistrict);
      setRegionType(12);
    } 
    else {
      setRegionCode(e.target.value);
      setRegionType(13);
    }
  }

  //--------DOWNLOAD PDF-------------------//
const downloadPDF = () => {
  const doc = new jsPDF({
    orientation: "p",
    unit: "mm",
    format: "a4",
  });

  // ----- PAGE DIMENSIONS -----
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // ----- TABLE WIDTH & MARGINS -----
  const tableWidth = 160;
  const leftMargin = (pageWidth - tableWidth) / 2;

  // ======= HEADER SECTION =======

  const drawHeader = (doc, leftMargin, pageWidth) => {
    const pageHeight = doc.internal.pageSize.getHeight();

    // 🔷 DIAGONAL WATERMARK (no translate / rotate)
    if (doc.GState && doc.setGState) {
      doc.setGState(new doc.GState({ opacity: 0.12 })); // optional transparency
    }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(50);
    doc.setTextColor(180, 180, 180); // light grey

    // Center par text, 45 degree rotate
    doc.text("UDISE+", pageWidth / 2, pageHeight / 2, {
      align: "center",
      angle: 45, // 👉 yahi rotation hai
    });

    if (doc.GState && doc.setGState) {
      doc.setGState(new doc.GState({ opacity: 1 }));
    }

    // ----- LEFT LOGO -----
    doc.addImage(udiseplusLogo, "PNG", leftMargin, 8, 18, 14);

    // ----- MAIN TITLE -----
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.setTextColor(20, 20, 20);
    doc.text("Fact Sheet Report", pageWidth / 2, 15, {
      align: "center",
    });

    // ----- SUB-TITLE -----
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);
    doc.text(
      "Unified District Information System for Education",
      pageWidth / 2,
      21,
      { align: "center" }
    );

    // ----- DIVIDER -----
    doc.setDrawColor(180, 180, 180);
    doc.setLineWidth(0.3);
    doc.line(12, 25, pageWidth - 12, 25);

    // ===== REGION LINE =====
doc.setFontSize(11);
doc.setFont("helvetica", "bold");
doc.setTextColor("#082C7C");

doc.text(`Region:`, leftMargin, 33);

let xPos = leftMargin + doc.getTextWidth("Region: ") + 2;

// Split last word & bold it
const regionParts = headingText.split(" / ");
if(regionParts[0] === 'ANDAMAN & NICOBAR ISLANDS') regionParts[0] = "A&N ISLANDS"
if(regionParts[0] === 'DADRA & NAGAR HAVELI AND DAMAN & DIU') regionParts[0] = "DNHDD"
if(regionParts[0] === 'JAMMU & KASHMIR') regionParts[0] = "J&K"

const lastPart = regionParts.pop();
const firstPart = regionParts.join(" / ");

// First Part
if (firstPart) {
  doc.setFont("helvetica", "normal");
  doc.text(firstPart + " / ", xPos, 33);
  xPos += doc.getTextWidth(firstPart + " / ");
}

// Last Part bold
doc.setFont("helvetica", "bold");
doc.text(lastPart, xPos, 33);

// ===== YEAR LINE (ALWAYS BELOW, NOT SAME LINE) =====
const yearText = `Data Source: UDISE+(${yearObj[selectedYear]})`;
doc.setFont("helvetica", "bold");
doc.setTextColor("#082C7C");

doc.text(yearText, leftMargin, 39);  // moved to next row
  };

  // Move down a bit
  let currentY = 48;

  // ======= TABLES =======
  tables.forEach((table) => {
    // Skip PGI State table only for National (99)
    if (
      table.title === "Performance Grading Index State" &&
      Number(selectedState) === 99
    ) {
      return; // Skip and continue to next table
    }

     //Skip PGI and GER table only when regionType = 13 for Blocks
    if ((table?.title === "Performance Grading Index State" || table?.title === "Gross Enrolment Ratio (GER)")  && Number(regionType) === 13) {
        return ;   // skip this table completely
    }

    // 🔥 If the current table is "Enrolments", force a new page
    if (
      table.title === "Enrolments" ||
      table.title === "Teachers" ||
      table.title === "Pupil Teacher Ratio (PTR)" ||
      table.title === "Infrastructure Facilities"
    ) {
      doc.addPage();
      currentY = 48; // reset Y position under header
    }

    // Table Title Block
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.setTextColor("#FFF");

    // light blue highlight bar behind title
    //doc.setFillColor(235, 242, 255);
    // light yellow highlight bar behind title
    doc.setFillColor("#082C7C"); // soft light yellow

    const barX = leftMargin;
    const barY = currentY - 6;
    const barWidth = tableWidth;
    const barHeight = 10;
    const radius = 4;

    // doc.rect(leftMargin, currentY - 5, tableWidth, 8, "F");
    doc.roundedRect(barX, barY, barWidth, barHeight, radius, radius, "F");
    doc.rect(barX, barY + radius, barWidth, barHeight - radius, "F");
    const pageWidth = doc.internal.pageSize.getWidth();
    doc.text(table.title, pageWidth / 2, currentY, { align: "center" });
    currentY += 2;

    const formatNumber = (num) => {
      if (num === null || num === undefined || num === "" || num === " / ")
        return " / ";
      if (isNaN(num)) return num;
      return new Intl.NumberFormat("en-IN").format(Number(num));
    };

    const tableRows = table.rows.map((r) => [
      r.label,
      r.label.includes("GER")
        ? data?.[r.value]
          ? formatNumber(data[r.value])
          : " / "
        : data
        ? formatNumber(data[r.value] || 0)
        : "0",
    ]);

    autoTable(doc, {
      head: [["Indicators", "Value"]],
      body: tableRows,
      startY: currentY + 1,

      margin: {
        top: 43, // 🔥 prevents header overlap
        left: leftMargin,
        right: leftMargin,
        bottom: 20,
      },

      tableWidth: tableWidth,

      styles: { fontSize: 9, minCellHeight: 4 },
      headStyles: { fillColor: [222, 226, 230], textColor: 0 },

      columnStyles: {
        0: { cellWidth: 130 },
        1: { cellWidth: 30, halign: "right", fontStyle: "bold" },
      },
      didParseCell: (doc) => {
        if (doc.section === "head" && doc.column.index === 1) {
          doc.cell.styles.halign = "right"; // Right-align header column 1
        }
      },
      theme: "grid",

      didDrawPage: (data) => {
        // 🔥 PRINT TOP HEADER ON EVERY PAGE
     

        drawHeader(doc, leftMargin, pageWidth);

           if (data.pageNumber > 1) {
          currentY = 48; // reset Y under header
        }
        // ----- FOOTER WITH PAGE NUMBER -----
        const pageCount = doc.getNumberOfPages();
        const pageInfo = doc.internal.getCurrentPageInfo();
        const currentPage = pageInfo.pageNumber;
        const pageSize = doc.internal.pageSize;

        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.text(
          `Page ${currentPage}`,
          pageSize.getWidth() / 2,
          pageSize.getHeight() - 10,
          { align: "center" }
        );

        // ---- PAGE FOOTER LINE ----
        doc.setDrawColor(180);
        doc.setLineWidth(0.2);
        doc.line(
          leftMargin,
          pageHeight - 15, // footer line height
          pageWidth - leftMargin,
          pageHeight - 15
        );

        // ---- BOTTOM LOGO ----
        doc.addImage(
          nicLogo,
          "PNG",
          leftMargin,
          pageHeight - 12, // keep 3mm below footer line
          10,
          4
        );

        // ----- RIGHT BOTTOM FOOTER TEXT -----
        const now = new Date();
        const formattedDate = now
          .toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
          .replace(",", "");

        const footerText = `Report generated on: ${formattedDate}`;
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");

        const textWidth = doc.getTextWidth(footerText);
        doc.text(
          footerText,
          pageWidth - leftMargin - textWidth,
          pageHeight - 10
        );
      },
    });

    const table1 = doc.lastAutoTable;

    doc.setLineWidth(0.4); // 🔥 make border thick
    doc.setDrawColor(0);

    const x = table1.settings.margin.left;
    const y = table1.settings.startY;
    const width = table1.settings.tableWidth;
    const height = table1.finalY - y;

    //doc.rect(x, y, width, height);
    // 🔹 Rounded border instead of normal rectangle
    // doc.roundedRect(x, y, width, height, 3, 3); // (radius 3px)

    currentY = doc.previousAutoTable.finalY + 12;
  });

  // ======== ADD MIGRATION TABLE AFTER ALL EXISTING TABLES ======== //
  if (migTables && migTables.length > 0) {
    doc.addPage(); // ⭐ Migration always on new page
    drawHeader(doc, leftMargin, pageWidth);
    currentY = 48;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.text("Migration Data", pageWidth / 2, currentY, { align: "center" });

    currentY += 8;

    migTables.forEach((table) => {
      let filteredRows = [];

      // MATCH YOUR SAME FILTER LOGIC
      if (
        (regionType == "10" && table?.migId == 0) ||
        (regionType == "11" && table?.migId == 1)
      ) {
        filteredRows = migData?.filter(
          (row) => row?.migId === 0 || row?.migId === 1
        );
      } else if (
        regionType == "12" &&
        (table?.migId == 2 || table?.migId == 3 || table?.migId == 4)
      ) {
        filteredRows = migData?.filter((row) =>
          [table.migId].includes(row?.migId)
        );
      }

      else if (
        regionType == "13" &&
        (table?.migId == 5 || table?.migId == 6 || table?.migId == 7 || table?.migId == 8)
      ) {
        filteredRows = migData?.filter((row) =>
          [table.migId].includes(row?.migId)
        );
      }


      if (!filteredRows || filteredRows.length === 0) return;

      // ---------- TOTAL CALCULATION ----------
      const totals = {
        ps1To5: filteredRows.reduce(
          (sum, r) => sum + Number(r?.ps1To5 || 0),
          0
        ),
        prePri: filteredRows.reduce(
          (sum, r) => sum + Number(r?.prePri || 0),
          0
        ),
        ups1To8: filteredRows.reduce(
          (sum, r) => sum + Number(r?.ups1To8 || 0),
          0
        ),
        ups6To8: filteredRows.reduce(
          (sum, r) => sum + Number(r?.ups6To8 || 0),
          0
        ),
        ss1To10: filteredRows.reduce(
          (sum, r) => sum + Number(r?.ss1To10 || 0),
          0
        ),
        ss6To10: filteredRows.reduce(
          (sum, r) => sum + Number(r?.ss6To10 || 0),
          0
        ),
        ss9To10: filteredRows.reduce(
          (sum, r) => sum + Number(r?.ss9To10 || 0),
          0
        ),
        hss1To12: filteredRows.reduce(
          (sum, r) => sum + Number(r?.hss1To12 || 0),
          0
        ),
        hss6To12: filteredRows.reduce(
          (sum, r) => sum + Number(r?.hss6To12 || 0),
          0
        ),
        hss9To12: filteredRows.reduce(
          (sum, r) => sum + Number(r?.hss9To12 || 0),
          0
        ),
        hss11To12: filteredRows.reduce(
          (sum, r) => sum + Number(r?.hss11To12 || 0),
          0
        ),
      };

      // Total of all values combined
      const grandTotal = Object.values(totals).reduce(
        (acc, val) => acc + val,
        0
      );

      // 🔥 FORCE A NEW PAGE FOR SPECIFIC TITLE
      if (table.title === "Migration to the district of another State" || table.title === "Total Migration to another Block and another District in same State") {
        doc.addPage();
        currentY = 48; // reset position after page header
      }

       // CUSTOM STYLE: LEFT ALIGN + SMALL FONT
      let titleAlign = "center"; 
      let titleFontSize = 12;

      if (table.title === "Total Migration to another Block and another District in same State") {
        titleFontSize = 10;  // smaller font
      }


      // Table Title Block
      doc.setFont("helvetica", "bold");
      doc.setFontSize(titleFontSize);
      doc.setTextColor("#000000");

      // light blue highlight bar behind title
      doc.setFillColor(235, 242, 255);

      doc.rect(leftMargin, currentY - 5, tableWidth, 8, "F");
      const pageWidth = doc.internal.pageSize.getWidth();
      doc.text(table.title, pageWidth / 2, currentY, { align: "center" });
      // Total Right
      doc.text(
        `Total: ${formatNumber(grandTotal)}`,
        leftMargin + tableWidth - 2,
        currentY,
        { align: "right" }
      );
      currentY += 2;

      // ---- TABLE HEADERS ----
      const head = [
        [
          "From\\To",
          "PS (1-5)",
          "UPS (1-8)",
          "UPS (6-8)",
          "SS (1-10)",
          "SS (6-10)",
          "SS (9-10)",
          "HSS (1-12)",
          "HSS (6-12)",
          "HSS (9-12)",
          "HSS (11-12)",
          "PRE (Pre-Primary)",
        ],
      ];

      // ---- TABLE ROWS ----
      const body = filteredRows.map((row) => [
        {
          1: "PS\n(1-5)",
          2: "UPS\n(1-8)",
          3: "HSS\n(1-12)",
          4: "UPS\n(6-8)",
          5: "HSS\n(6-12)",
          6: "SS\n(1-10)",
          7: "SS\n(6-10)",
          8: "SS\n(9-10)",
          10: "HSS\n(9-12)",
          11: "HSS\n(11-12)",
        }[row.schCategoryId] || "PRE (Pre-Primary)",

        row.ps1To5,
        row.ups1To8,
        row.ups6To8,
        row.ss1To10,
        row.ss6To10,
        row.ss9To10,
        row.hss1To12,
        row.hss6To12,
        row.hss9To12,
        row.hss11To12,
        row.prePri,
      ]);

      autoTable(doc, {
        head,
        body,
        startY: currentY,
        margin: { left: leftMargin, right: leftMargin },
        tableWidth: tableWidth,
        styles: { fontSize: 8, minCellHeight: 5 },
        headStyles: { fillColor: [52, 73, 94], textColor: 255 },
        theme: "grid",

        // BOLD ONLY FIRST COLUMN (index 0)
        didParseCell(data) {
          // Bold + center align first column (From\To)
          if (data.section === "body" && data.column.index === 0) {
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.halign = "center";
            return;
          }

          // 👉 Right-align all *value* columns (index >= 1)
          if (data.section === "body" && data.column.index >= 1) {
            data.cell.styles.halign = "right";
          }
        },

        didDrawPage: (data) => {
          drawHeader(doc, leftMargin, pageWidth);

          // FOOTER + PAGE NUMBER
          const pageCount = doc.getNumberOfPages();
          const pageInfo = doc.internal.getCurrentPageInfo();
          const currentPage = pageInfo.pageNumber;

          doc.setFontSize(8);
          doc.text(`Page ${currentPage}`, pageWidth / 2, pageHeight - 10, {
            align: "center",
          });

          doc.setDrawColor(180);
          doc.line(
            leftMargin,
            pageHeight - 15,
            pageWidth - leftMargin,
            pageHeight - 15
          );

          doc.addImage(nicLogo, "PNG", leftMargin, pageHeight - 12, 10, 4);

          const now = new Date();
          const formattedDate = now
            .toLocaleString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            })
            .replace(",", "");

          const footerText = `Report generated on: ${formattedDate}`;
          const textWidth = doc.getTextWidth(footerText);
          doc.text(
            footerText,
            pageWidth - leftMargin - textWidth,
            pageHeight - 10
          );
        },
      });

      currentY = doc.lastAutoTable.finalY + 10;
    });
  }

  doc.save(headingText + "_fact_sheet_data.pdf");
};

  const formatNumber = (num) => {
  if (num === null || num === undefined || num === "" || num === " / ") return " / ";
  if (isNaN(num)) return num;
  return new Intl.NumberFormat("en-IN").format(Number(num));
};
  // ---------- Dynamic Heading Logic (Improved with Safe Fallbacks) ----------

  // 1) Get State Name 
  const stateObj = stateData?.data?.data?.find(
    (s) => Number(s.udiseStateCode) === Number(selectedState)
  );

  const selectedStateName =
    Number(selectedState) === 99
      ? "National"
      : stateObj?.udiseStateName || "State";

  // 2) Get District Name 
  const districtObj = districtData?.data?.data?.find(
    (d) => Number(d.udiseDistrictCode) === Number(selectedDistrict)
  );

  const selectedDistrictName =
    Number(selectedDistrict) === 10 ? "" : districtObj?.udiseDistrictName || "";

  // 2) Get Block Name 
  const blockObj = blockData?.data?.data?.find(
    (d) => Number(d.udiseBlockCode) === Number(selectedBlock)
  );

  const selectedBlockName =
    Number(selectedBlock) === 12 ? "" : blockObj?.udiseBlockName || "";

  let headingText = "National";

// State selected?
if (Number(selectedState) !== 99) {
  headingText = selectedStateName;
}

// District selected?
if (Number(selectedState) !== 99 && Number(selectedDistrict) !== 10) {
  headingText = `${selectedStateName} / ${selectedDistrictName}`;
}

// Block selected?
if (
  Number(selectedState) !== 99 &&
  Number(selectedDistrict) !== 10 &&
  Number(selectedBlock) !== 12
) {
  headingText = `${selectedStateName} / ${selectedDistrictName} / ${selectedBlockName}`;
}


  console.log("headingText", headingText);

  return (
    <div className="container-fluid min-vh-100 py-4 highlight-page">
      {/* Header Section */}
      <div className="infrastructure-main-card">
        <div className="card-header-2 tab-for-graph">
          <div className="card-body filter-card">
            <div className="row g-3 align-items-center">
              {/* Left Title */}
              <div className="col-2 col-md-4">
                <p className="mb-1 small">Data Highlights:</p>
                <h4 className="fw-bold mb-0">{headingText}</h4>
              </div>

              {/* Year Dropdown */}
              <div className="col-6 col-md-2">
                <div className="indicator-select mt-2">
                  <label className="bg-grey2">Select Year</label>
                  <select
                    className="form-select bg-grey2"
                    value={selectedYear ?? ""}
                    onChange={handleYearChange}
                  >
                    {yearData?.filter((item) => [11, 12].includes(item.yearId))
                    .map((item) => (
                      <option key={item.yearId} value={item.yearId}>
                        {item.yearDesc}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* State Dropdown */}
              <div className="col-6 col-md-2">
                <div className="indicator-select mt-2">
                  <label className="bg-grey2">Select State/UT's</label>
                  <select
                    className="form-select bg-grey2"
                    value={selectedState ?? ""}
                    onChange={handleStateChange}
                  >
                    <option value="99">National</option>
                    {stateData?.data?.data?.map((item) => (
                      <option
                        key={item.udiseStateCode}
                        value={item.udiseStateCode}
                      >
                        {item.udiseStateName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* District Dropdown */}
              <div className="col-6 col-md-2">
                <div className="indicator-select mt-2">
                  <label className="bg-grey2">Select District</label>
                  <select
                    className="form-select bg-grey2"
                    value={selectedDistrict ?? ""}
                    onChange={handleDistrictChange}
                  >
                    <option value="10">All</option>
                    {districtData?.data?.data?.map((item) => (
                      <option
                        key={item.udiseDistrictCode}
                        value={item.udiseDistrictCode}
                      >
                        {item.udiseDistrictName}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

               {/* Block Dropdown */}
              {/* <div className="col-6 col-md-2">
                <div className="indicator-select mt-2">
                  <label className="bg-grey2">Select Block</label>
                  <select
                    className="form-select bg-grey2"
                    value={selectedBlock ?? ""}
                    onChange={handleBlockChange}
                  >
                    <option value="12">All</option>
                    {blockData?.data?.data?.map((item) => (
                      <option
                        key={item.udiseBlockCode}
                        value={item.udiseBlockCode}
                      >
                        {item.udiseBlockName}
                      </option>
                    ))}
                  </select>
                </div>
              </div> */}

               <div className="col-6 col-md-1">
                <div className="indicator-select mt-2 btn-reset">
                  <button className="download-btn-report" onClick={handleResetBtn}>
                     <img src={resetIcon} alt="Reset Icon" height={35} width={35}/>
                  </button>
                </div>
              </div>
              <div className="col-6 col-md-1">
                <div className="indicator-select mt-2">
                  <button className="download-btn-report" onClick={downloadPDF}>
                    <img src={downloadIcon} alt="Download Icon" height={35} width={35}/>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table Section */}
      {/* Accordion Table Section */}
      <div className="accordion mt-3" id="dynamicAccordion">
  
  {/* ----------------------------------- */}
  {/* EXISTING ACCORDION ITEMS (tables) */}
  {/* ----------------------------------- */}

 {tables?.map((table, index) => {

    //Skip PGI State table only when selectedState = 99
    if (table?.title === "Performance Grading Index State" && Number(selectedState) === 99) {
        return null;   // skip this table completely
    }

    //Skip PGI and GER table only when regionType = 13 for Blocks
    if ((table?.title === "Performance Grading Index State" || table?.title === "Gross Enrolment Ratio (GER)")  && Number(regionType) === 13) {
        return null;   // skip this table completely
    }

    return (
      <div className="accordion-item" key={`tbl-${index}`}>
        <h2 className="accordion-header" id={`heading-${index}`}>
          <button
            className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#collapse-${index}`}
          >
            {table?.title}
          </button>
        </h2>

        <div
          id={`collapse-${index}`}
          className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
          data-bs-parent="#dynamicAccordion"
        >
          <div className="accordion-body">
            <table className="table-bordered w-100 mb-0">
              <thead>
                <tr>
                  <th>Indicators</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                {table?.rows.map((row, i) => (
                  <tr key={i}>
                    <td>{row?.label}</td>
                    <td>
                      {row?.label?.includes("GER")
                        ? data?.[row.value]
                          ? formatNumber(data[row.value])
                          : "-"
                        : formatNumber(data?.[row.value] || 0)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
})}


  {/* NEW ACCORDION ITEM — MIGRATION DATA (CUSTOM HTML) */}

  <div className="accordion-item">
    <h2 className="accordion-header" id="heading-migration">
      <button
        className="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#collapse-migration"
      >
        Migration Data
      </button>
    </h2>

    <div
      id="collapse-migration"
      className="accordion-collapse collapse"
      data-bs-parent="#dynamicAccordion"
    >
      <div className="accordion-body">

        {/* FULL MIGRATION HTML GOES HERE */}

        <div className="mt-3">

          {migTables?.map((table, index) => {
            let filteredRows = [];

            if (
              (regionType == "10" && table?.migId == 0) ||
              (regionType == "11" && table?.migId == 1)
            ) {
              filteredRows = migData?.filter((row) => row?.migId === 0 || row?.migId === 1);
            } else if (
              regionType == "12" &&
              (table?.migId == 2 || table?.migId == 3 || table?.migId == 4)
            ) {
              filteredRows = migData?.filter((row) =>
                [table.migId].includes(row?.migId)
              );
            }else if (
              regionType == "13" &&
              (table?.migId == 5 || table?.migId == 6 || table?.migId == 7 || table?.migId == 8)
            ) {
              filteredRows = migData?.filter((row) =>
                [table.migId].includes(row?.migId)
              );
            }

            if (filteredRows?.length === 0) return null;

              // ---------- TOTAL CALCULATION ----------
              const totals = {
                ps1To5: filteredRows?.reduce((sum, r) => sum + Number(r?.ps1To5 || 0), 0),
                prePri: filteredRows?.reduce((sum, r) => sum + Number(r?.prePri || 0), 0),
                ups1To8: filteredRows?.reduce((sum, r) => sum + Number(r?.ups1To8 || 0), 0),
                ups6To8: filteredRows?.reduce((sum, r) => sum + Number(r?.ups6To8 || 0), 0),
                ss1To10: filteredRows?.reduce((sum, r) => sum + Number(r?.ss1To10 || 0), 0),
                ss6To10: filteredRows?.reduce((sum, r) => sum + Number(r?.ss6To10 || 0), 0),
                ss9To10: filteredRows?.reduce((sum, r) => sum + Number(r?.ss9To10 || 0), 0),
                hss1To12: filteredRows?.reduce((sum, r) => sum + Number(r?.hss1To12 || 0), 0),
                hss6To12: filteredRows?.reduce((sum, r) => sum + Number(r?.hss6To12 || 0), 0),
                hss9To12: filteredRows?.reduce((sum, r) => sum + Number(r?.hss9To12 || 0), 0),
                hss11To12: filteredRows?.reduce((sum, r) => sum + Number(r?.hss11To12 || 0), 0)
              };


              console.log(totals)
            return (
              <div key={index} className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-2 totalNumber">
                  <h5 className="mb-0">{table?.title}</h5>
                  <strong>
                    <span >Total:{" "}</span>
                    {formatNumber(Object.values(totals)?.reduce((acc, v) => acc + v, 0))}
                  </strong>
                </div>

                <table className="table-bordered w-100 mb-0">
                  <thead>
                    <tr>
                      <th>From\To</th>
                      <th>PS (1-5)</th>
                      <th>UPS (1-8)</th>
                      <th>UPS (6-8)</th>
                      <th>SS (1-10)</th>
                      <th>SS (6-10)</th>
                      <th>SS (9-10)</th>
                      <th>HSS (1-12)</th>
                      <th>HSS (6-12)</th>
                      <th>HSS (9-12)</th>
                      <th>HSS (11-12)</th>
                      <th>PRE (Pre-Primary)</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredRows?.map((row, i) => (
                      <tr key={i}>
                        <td className="firstCol">
                          {{
                            1: "PS\n(1-5)",
                            2: "UPS\n(1-8)",
                            3: "HSS\n(1-12)",
                            4: "UPS\n(6-8)",
                            5: "HSS\n(6-12)",
                            6: "SS\n(1-10)",
                            7: "SS\n(6-10)",
                            8: "SS\n(9-10)",
                            10: "HSS\n(9-12)",
                            11: "HSS\n(11-12)",
                          }[row?.schCategoryId] || "PRE (Pre-Primary)"}
                        </td>

                        <td>{row?.ps1To5}</td>
                        <td>{row?.ups1To8}</td>
                        <td>{row?.ups6To8}</td>
                        <td>{row?.ss1To10}</td>
                        <td>{row?.ss6To10}</td>
                        <td>{row?.ss9To10}</td>
                        <td>{row?.hss1To12}</td>
                        <td>{row?.hss6To12}</td>
                        <td>{row?.hss9To12}</td>
                        <td>{row?.hss11To12}</td>
                        <td>{row?.prePri}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            );
          })}
        </div>

      </div>
    </div>
  </div>
</div>

    </div>
  );
}
